import { type QuestionnaireReportTableVariant } from './types';

export const TOP_BAND_ROW_HEIGHT = 48;
export const COLUMN_LABEL_ROW_HEIGHT = 44;
export const DATA_ROW_HEIGHT = 40;
export const EMPTY_MESSAGE_ROW_HEIGHT = 60;

export const COLUMN_WIDTHS = {
  index: 36,
  option: 420,
  count: 80,
  pass: 80,
  fail: 80,
  passingRate: 114,
} as const;

export const GROUP_WIDTH =
  COLUMN_WIDTHS.count + COLUMN_WIDTHS.pass + COLUMN_WIDTHS.fail + COLUMN_WIDTHS.passingRate;

export const TITLE_WIDTH = COLUMN_WIDTHS.index + COLUMN_WIDTHS.option;

export const METRIC_COLUMNS = [
  { key: 'count', label: 'Count', width: COLUMN_WIDTHS.count },
  { key: 'pass', label: 'Pass', width: COLUMN_WIDTHS.pass },
  { key: 'fail', label: 'Fail', width: COLUMN_WIDTHS.fail },
  { key: 'passingRate', label: 'Passing Rate', width: COLUMN_WIDTHS.passingRate },
] as const;

export const METRIC_GROUPS = [
  { key: 'combined', label: 'Public + In-house' },
  { key: 'public', label: 'Public' },
  { key: 'inHouse', label: 'In-house' },
] as const;

export function getTopBandColors(variant: QuestionnaireReportTableVariant) {
  const isRating = variant === 'rating';
  return {
    backgroundColor: isRating ? '#fddb8a' : '#262626',
    color: isRating ? 'text.primary' : 'common.white',
  };
}

export function getTopBandDividerColor(variant: QuestionnaireReportTableVariant): string {
  return variant === 'rating' ? '#262626' : '#525252';
}

export const OUTER_BORDER_COLOR = '#262626';

export const GROUP_DIVIDER_SX = { borderLeft: `1px solid ${OUTER_BORDER_COLOR}` } as const;

export const ROW_DIVIDER_SX = { borderBottom: '1px solid #d4d4d4' } as const;

export const CELL_DIVIDER_SX = { borderRight: '1px solid #d4d4d4' } as const;
